module.exports = __webpack_public_path__ + "img/benefit_marquee-event-ticket-access.5d97a23c.jpg";